import React, { useMemo } from "react";
import ScriptComponent from "../../components/ScriptComponent";
import { mapQuoteDataToScriptProps } from "./utils";
import styles from "./OrderInitiatePage.module.css";

const DocIcon = () => (
  <svg
    className={styles.scripSelectionTitleIcon}
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="12"
    viewBox="0 0 10 12"
    fill="none"
    aria-hidden
  >
    <path
      d="M2.33333 8.16667H7V9.33333H2.33333V8.16667ZM2.33333 5.83333H7V7H2.33333V5.83333ZM5.83333 0H1.16667C0.525 0 0 0.525 0 1.16667V10.5C0 11.1417 0.519167 11.6667 1.16083 11.6667H8.16667C8.80833 11.6667 9.33333 11.1417 9.33333 10.5V3.5L5.83333 0ZM8.16667 10.5H1.16667V1.16667H5.25V4.08333H8.16667V10.5Z"
      fill="currentColor"
    />
  </svg>
);

const ScriptComponentWrapper = React.memo(
  React.forwardRef(
    (
      {
        id,
        index,
        dropdownOptions,
        selection,
        onSelectionChange,
        onDelete,
        onAddScript,
        animateIn,
        quoteData,
        selected,
        onSelectedChange,
        validityOptions,
      },
      ref
    ) => {
      const quoteProps = useMemo(() => mapQuoteDataToScriptProps(quoteData), [quoteData]);
      return (
        <div ref={ref}>
          <ScriptComponent
            id={id}
            scriptIndex={index}
            dropdownOptions={dropdownOptions}
            selection={selection}
            onSelectionChange={onSelectionChange}
            onDelete={onDelete}
            onAddScript={onAddScript}
            animateIn={animateIn}
            selected={selected}
            onSelectedChange={onSelectedChange}
            validityOptions={validityOptions}
            {...quoteProps}
          />
        </div>
      );
    }
  )
);

function ScriptListSection({
  scriptIds,
  lastAddedScriptId,
  lastAddedScriptRef,
  scriptDropdowns,
  scriptSelections,
  quoteDataList,
  selectedScriptIds,
  validityOptions,
  onAddScrip,
  onDeleteScrip,
  onScriptSelectionChange,
  onScriptSelectedChange,
}) {
  const scrollClassName = scriptIds.length > 2 ? styles.scripSelectionScrollInner : undefined;

  return (
    <section className={styles.scripSelectionContainer}>
      <div className={styles.scripSelectionHeader}>
        <h2 className={styles.scripSelectionTitle}>
          <DocIcon />
          SCRIP SELECTION
        </h2>
        <button type="button" className={styles.addScripBtn} onClick={onAddScrip}>
          + Add Scrip
        </button>
      </div>
      <div className={scrollClassName}>
        <div className={styles.scriptList}>
          {scriptIds.map((id, index) => (
            <ScriptComponentWrapper
              key={id}
              ref={id === lastAddedScriptId ? lastAddedScriptRef : null}
              id={id}
              index={index}
              dropdownOptions={
                scriptDropdowns?.quote_drop_down_options_list?.[index] ??
                scriptDropdowns?.quote_drop_down_options_list?.[0]
              }
              selection={scriptSelections[index]}
              onSelectionChange={onScriptSelectionChange}
              onDelete={scriptIds.length > 1 ? onDeleteScrip : undefined}
              onAddScript={onAddScrip}
              animateIn={id === lastAddedScriptId}
              quoteData={quoteDataList[index]}
              selected={selectedScriptIds.has(id)}
              onSelectedChange={(checked) => onScriptSelectedChange(id, checked)}
              validityOptions={validityOptions}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default React.memo(ScriptListSection);
